import {Injectable} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Logger} from '../utils/Logger';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable()
export class ReferralService {

    constructor(private apiService: ApiServiceService, private http: HttpClient) {
    }

    async verifyReferralCode(referralCode: string): Promise<boolean> {
        const url = this.apiService.baseURL() + 'referral/' + referralCode + '/verify';

        // TODO Add test for different scenarios
        try {
            await this.http.get<any>(url).toPromise();
            return true;
        } catch (error) {
            Logger.error('Error while verifying the referral code', error);
            return false;
        }
    }

    async fetchReferralDetails(profileId: string, token: string): Promise<any> {
        const url = this.apiService.baseURL() + 'referral';

        const queryParams = new HttpParams();
        queryParams.set('profile_id', profileId);
        queryParams.set('token', token);

        return await this.http.get<any>(url, {params: queryParams}).toPromise();
    }
}
